import type { FileReplicationProgressResult } from "@/services/abstract/poc/messaging.service.interface";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:file-replication-progress' });

export const createFileReplicationProgressHandler = (): MessageHandler<FileReplicationProgressResult> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'file-replication-progress',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): FileReplicationProgressResult => {
    if (message.type !== 'file-replication-progress') {
      throw new Error(`Invalid message type: expected 'file-replication-progress', got '${message.type}'`);
    }

    const { cid, sixId, stage, bytesTransferred, totalBytes, targetPeerId, sender, timestamp } = message;
    log.info('Received file-replication-progress for CID:', cid, 'sixId:', sixId, 'stage:', stage, 'from', sender);

    return {
      cid,
      sixId,
      stage,
      bytesTransferred,
      totalBytes,
      targetPeerId,
      sender,
      messageTimestamp: timestamp
    };
  }
});
